import React from "react";
import { Container } from "@chakra-ui/react";
import ListCategory from "views/admin/Category/components/ListCategory";

const Category = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListCategory />
    </Container>
  );
};

export default Category;
